import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';

import { MerchantAwareLink as Link } from '../../../../components/core/MerchantAwareLink';
import { ConfigurationPath } from '../../../../util/constants';

type SubTitleDisplayTestIds = {
  message: string;
  subTitle: string;
};

type SubTitleDisplayProps = {
  message: string;
  route: ConfigurationPath;
  subTitle: string;
  dataTestIds?: SubTitleDisplayTestIds;
};

const TEST_ID_PREFIX = 'GoCartSubTitleDisplay';

const DEFAULT_TESTIDS: SubTitleDisplayTestIds = {
  message: `${TEST_ID_PREFIX}-message`,
  subTitle: `${TEST_ID_PREFIX}-subtitle`,
};

export const SubTitleDisplay: FC<SubTitleDisplayProps> = (props) => {
  const { message, route, subTitle, dataTestIds = DEFAULT_TESTIDS } = props;
  return (
    <Stack component="section" spacing={1}>
      <Typography
        component="h3"
        variant="large"
        fontWeight="bold"
        color="text.primary"
        data-testid={dataTestIds.subTitle}
        sx={{ '& a': { color: 'inherit' } }}
      >
        <Link to={route}>{subTitle}</Link>
      </Typography>
      <Typography color="text.secondary" data-testid={dataTestIds.message}>
        {message}
      </Typography>
    </Stack>
  );
};

export const test = {
  DEFAULT_TESTIDS,
};
